import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { ThumbsUp, ThumbsDown } from 'react-feather';
import useNotificationFeedbackController from '../Hooks/useNotificationFeedbackController.js';
import LoadingButton from '../../LoadingButton.js';
import { CustomTextArea } from '../../common.js';

const OnCloseFeedback = ({ open, onClose, data }) => {
  const [state, handlers] = useNotificationFeedbackController({ data, onClose });

  const theme = useTheme();
  const fillStyles = (variant = 'secondary') => ({
    fill: theme.palette[variant].main,
    color: theme.palette[variant].main,
  });

  return (
    <Dialog
      sx={{
        '.MuiPaper-root': {
          padding: '16px',
        },
      }}
      open={open}
      onClose={state.isSubmittingFeedback ? () => {} : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Was this notification helpful?</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'center' }}>
            <IconButton onClick={() => handlers.handleFeedbackVote(true)}>
              <ThumbsUp
                height={50}
                width={50}
                {...(state.feedbackVote === true && {
                  style: fillStyles(),
                })}
              />
            </IconButton>
            <IconButton onClick={() => handlers.handleFeedbackVote(false)}>
              <ThumbsDown
                height={50}
                width={50}
                {...(state.feedbackVote === false && {
                  style: fillStyles('error'),
                })}
              />
            </IconButton>
          </Box>
          <Typography sx={{ fontSize: '12px', color: 'var(--color-hover-charcol)' }}>
            Let us know what you think! (Optional)
          </Typography>
          <CustomTextArea
            disabled={state.isSubmittingFeedback}
            onChange={(e) => handlers.handleFeedbackmessage(e.target.value)}
            value={state.feedbackMessage}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '12px 22px' }}>
        <LoadingButton
          isLoading={state.isSubmittingFeedback}
          onClick={handlers.handleSubmitFeedback}
          variant="contained"
          size="small"
          disabled={state.feedbackVote === null || state.isSubmittingFeedback}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default OnCloseFeedback;
